// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_n5-5";
export var filledCircle = "_n5-4";
export var historyEntry = "_n5-3";
export var messageSideLeft = "_n5-1";
export var messageSideRight = "_n5-2";
export var orderTrackingCarouselWrapper = "_n5-6";
export var orderTrackingInfoContainer = "_n5-0";